jQuery(function ($) {
    // Function to toggle 'active' class on .header-fixed
    function toggleHeader() {
        // Get the height of .header-placeholder
        const placeholderHeight = $('.header-placeholder').outerHeight() * 2 || 0;
        // If scrolled beyond that height, add 'active', else remove it
        if ($(window).scrollTop() > placeholderHeight) {
            $('.header-fixed').addClass('active');
        } else {
            $('.header-fixed').removeClass('active');
        }
    }

    // Run on page load and on scroll
    $(window).on('load scroll', toggleHeader);

    $('.menu-opener').on('click', function () {
        $(this).toggleClass('-open');
        if($(this).hasClass('-open')) {
            $('.hidden-menu').slideDown();
            $('body').addClass('overflow-hidden');
        } else {
            $('.hidden-menu').slideUp();
            $('body').removeClass('overflow-hidden');
        }
    });

    $('.hidden-menu').on('click', function(e) {
        if (e.target === this) {
            $(this).slideUp();
            $('body').removeClass('overflow-hidden');
            $('.menu-opener').removeClass('-open');
        }
    });
});
